<div class="column-manager">
  <div class="column-manager-header">
    <h3 mat-dialog-title>Justera kolumner</h3>
    <button mat-icon-button (click)="onClose()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="search-container">
    <mat-form-field appearance="outline" class="search-filter">
      <mat-label>Sök kolumner</mat-label>
      <input matInput [(ngModel)]="searchTerm" placeholder="Skriv för att söka..." class="search-input">
      <mat-icon matSuffix>search</mat-icon>
      @if (searchTerm()) {
      <button matSuffix mat-icon-button (click)="clearSearch()">
        <mat-icon>clear</mat-icon>
      </button>
      }
    </mat-form-field>
  </div>

  <div class="column-manager-content" cdkScrollable>
    <div cdkDropList [cdkDropListAutoScrollStep]="10" (cdkDropListDropped)="onDrop($event)">
      @for (column of filteredColumns(); track $index) {
      <div class="column-item" cdkDrag [cdkDragDisabled]="column.required">
        <div class="drag-handle" cdkDragHandle>
          <mat-icon>drag_indicator</mat-icon>
        </div>
        <mat-checkbox [checked]="column.visible" [disabled]="column.required"
          (change)="onCheckboxChange(column, $event)" class="column-checkbox">
          {{ column.header }}
        </mat-checkbox>
        @if (column.required) {
        <mat-icon class="required-icon" matTooltip="Required column">
          lock
        </mat-icon>
        }

      </div>
      }

    </div>
  </div>

  <div class="column-manager-actions">
    <button mat-button (click)="onSelectAll()">Välj alla</button>
    <button mat-button (click)="onDeselectAll()">Ta bort alla</button>
    <button mat-button (click)="onReset()">Ångra</button>
    <button mat-button (click)="onResetToDefault()">Standard</button>

    <div class="action-buttons">
      <button mat-button (click)="onClose()">Avbryt</button>
      <button mat-raised-button class="main-action-button" color="primary" (click)="onSave()">
        Spara
      </button>
    </div>
  </div>
</div>